var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"403","title":"到期","sub-title":"很抱歉, 您的店铺已经过期."},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('router-link',{attrs:{"to":"/mendian"}},[_c('a-button',{attrs:{"type":"primary"}},[_vm._v(" 返回 ")])],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }